module.exports = __webpack_public_path__ + "static/media/material-report.4e3d84fc.svg";